import { useEffect, useState } from "react";
import { EmpresaService } from "../../services";
import { responseErros } from "../../utils";

export function useColunaFilial(colunas, aberto) {
  const [empresas, setEmpresas] = useState([]);
  const empresaService = new EmpresaService();

  useEffect(() => {
    if (aberto && !empresas.length) {
      buscarEmpresas();
    }
  }, [aberto]);

  const buscarEmpresas = async () => {
    const result = await empresaService.getFiliaisMatriz();
    if (!result.isAxiosError) {
      setEmpresas(result.data);
    } else {
      responseErros(result);
    }
  };

  if (empresas.length <= 1) return colunas;

  return [
    ...colunas,
    {
      field: "empresaId",
      headerName: "Filial",
      flex: 450,
      valueGetter: (params) => {
        const empresa = empresas.find((item) => item.id == params.value);
        if (!empresa) return params.value;
        return empresa.fantasia;
      },
    },
  ];
}
